import * as React from "react";
import LoginContainer from "../../containers/login/LoginContainer";

export default function LoginPage(props)
{
    return <LoginContainer {...props} />;
}
